import React from 'react';

import { UpgradePrompt } from './UpgradePrompt';

interface LimitReachedGateProps {
  /** When true, the children are blurred/disabled and an upgrade overlay is shown. */
  reached: boolean;
  title: string;
  description: string;
  children: React.ReactNode;
}

/**
 * Wraps a region and, when a plan quota is reached, blurs it (non-interactive)
 * and overlays an "upgrade to continue" card — the limit analogue of FeatureGate.
 */
export const LimitReachedGate: React.FC<LimitReachedGateProps> = ({ reached, title, description, children }) => {
  if (!reached) return <>{children}</>;

  return (
    <div className="relative size-full" data-testid="limit-reached-gate">
      {/* Blurred, non-interactive content behind the overlay: the vendor can
          see what they are missing without being able to reach it. */}
      <div aria-hidden className="pointer-events-none size-full opacity-60 blur-[4px] select-none">
        {children}
      </div>

      <div className="absolute inset-0 flex items-center justify-center p-4">
        <UpgradePrompt className="max-w-lg" title={title} description={description} />
      </div>
    </div>
  );
};

export default LimitReachedGate;
